export default {
	position: '#',
	username: 'Name',
	gift: 'Prize',
	score: 'Points',
};
